import React from "react";
import { Navigate } from "react-router-dom";
import { useLoginContext } from "../context/loginContext";
import { role } from "../utils/globalVariables";
import { safetyDecodeJWT } from "../utils/globalFunctions";

const OwnerRoute = ({ stateComponent }) => {

    const { loginContext } = useLoginContext();

    try {
        if (safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl') === role.owner.subLevel.owner.slugSubLevel) {
            return stateComponent;
        }
        else {
            return <Navigate to='/' replace={true} />;
        }
    } catch (error) {
        return <Navigate to='/' replace={true} />;
    }
}

export default OwnerRoute;